import React, { useState, useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	Row
} from 'reactstrap'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionTabsService from '../../services/AuctionTabsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'

/**
 * Modal for releasing an auction from hold.
 * BRD: Release from Hold workflow with optional notes.
 */
const ReleaseFromHoldModal = ({ isOpen = false, auction = null, onClose, onSuccess }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const sessionContext = useContext(SessionContext)

	// Get VIN and bid info for BRD mockup format
	const vin = auction?.vin || auction?.vehicleVin || ''
	const bidCount = auction?.bidCount ?? auction?.bidsCount ?? auction?.bids ?? 0
	const hasBids = bidCount > 0

	const handleCancelModal = () =>
	{
		if (typeof onClose === 'function')
		{
			onClose()
		}
	}

	const handleReleaseFromHold = () =>
	{
		setIsModalBusy(true)
		AuctionTabsService
			.releaseFromHold(auction.auctionId, '', sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				trigger('raiseNotification', { title: 'Hold Released', message: 'The auction has been released from hold and is now active.', type: 'success', duration: 5 })
				if (typeof onSuccess === 'function')
				{
					onSuccess()
				}
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}

	return (
		<Modal
			className="modal-dialog-centered"
			size="md"
			isOpen={isOpen}
		>
			<SpinnerComponent
				loading={isModalBusy}
				position="centered"
				message="Processing..."
			/>
			<Card className="mb-0">
				<CardBody>
					{/* BRD: Title shows VIN and bid status */}
					<div className="text-muted mb-3">
						<strong>
							{hasBids ? `VIN:${vin} has a bid on it` : `VIN:${vin}`}
						</strong>
					</div>
					
					{/* BRD: Simple confirmation message */}
					<p className="mb-4">
						Would you like to release this unit from Hold
					</p>

					<Row>
						<Col className="text-center">
							<Button
								color="primary"
								className="me-2"
								onClick={handleReleaseFromHold}
							>
								YES
							</Button>
							<Button
								color="secondary"
								onClick={handleCancelModal}
							>
								Cancel
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Modal>
	)
}

export default ReleaseFromHoldModal
